import { connect } from 'react-redux';
import DataRoom from '../../../components/data_room';

import {
  createSection,
  renameSection,
  deleteSection,
  updateSectionPosition,
  createFile,
  moveFile,
  updateFile,
  updateFilePosition,
  deleteFile,
} from '../../../api/investor/investment/dataRoomApi';

const mapStateToProps = state => ({
  editor: !state.currentUser.investorGuest,
  dataRoom: state.dataRoom,
  blockFileDownload: state.currentUser ? state.currentUser.blockFileDownload : false,
});

const mapDispatchToProps = {
  createSection,
  renameSection,
  deleteSection,
  updateSectionPosition,
  createFile,
  moveFile,
  updateFile,
  updateFilePosition,
  deleteFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataRoom);
